/**
 * @summary - Component that Provides RI Functionality
 * @author vengateshwaran k
 * @since 2024-07-28
 */
import {Box,Button,Grid,Stack} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import commonMasterRepository from '../../api/repositories/commonMasterRepository';
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import {
  getAuthToken,
  getFacilityId,
  getcompanyId,
} from "../../utility/tokenUtility";
import CreateNewButton from "../commoncomponents/CreateNewButton";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import SectionTitle from "../commoncomponents/SectionTitle";
import RoutineInspectionRepository from "../../api/repositories/routineInspectionRepository";
import { addDays, addMonths, addWeeks, format, isBefore, parseISO } from 'date-fns';
import PageLoader from "../commoncomponents/PageLoader";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";

import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
export default function RoutineInspectionList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [gridApi, setGridApi] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [serviceOptions, setServiceOptions] = useState();
  const [serviceType, setServiceType] = useState();
  const token = getAuthToken("id_token");
  const companyId = getcompanyId("companyId");
  const facilityId = getFacilityId("facilityId");
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [allTracks, setAllTracks] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasRun = useRef(false);
  const [gridLoading, setGridLoading] = useState(false);
  const columns = [
    { field: "assetno", headerName: "Asset No", width: 150 },
    { field: "locationcode", headerName: "Location Code", width: 150 },
    { field: "locationdesc", headerName: "Location Description", width: 150 },
    { field: "assetclassification", headerName: "Asset Classification Code", width: 180 },
    { field: "typecode", headerName: "Asset Type Code", width: 180, },
    { field: "typedescription", headerName: "Asset Type Description", width: 150 },
    { field: "taskcode", headerName: "Task Code", width: 150 },
    { field: "employeename", headerName: "Assignee", width: 150 },
    { field: "frequencyunit", headerName: "Schedule Frequency", width: 150,cellStyle: { textAlign: "right" }},
    { field: "intervaltypedesc", headerName: "Interval Type", width: 150 },
    { field: "agreeddateChanged", headerName: "Agreed Date", width: 150 },
    { field: "targetdateChanged", headerName: "Next Date", width: 150 },
    // { field: "isactive", headerName: "Status", width: 150 },
    {
      field: "isactive", headerName: "Status", width: 150,
      // cellRenderer: (params) => {
      //   if (params.value == true) {
      //     return <SuccessChips label="Active" />;
      //   } else {
      //     return <ErrorChips label="Inactive" />;
      //   }
      // }
    }
  ]

  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "RIPT001");

  // const fetchList = async () => {
  //   try {
  //     setLoading(true);
  //     setGridLoading(true);
  //     if (serviceType?.label === 'FEMS') {
  //       const pdmList = await RoutineInspectionRepository.getRIList(facilityId,pageSize,pageIndex,filterModel,sortModel);
  //       const list = pdmList?.data?.items?.map((item) => {
  //         console.log(item,"item");
          
  //         // Calculate next date based on interval type with frequency Unit
  //         let nextDate;
  //         const startFromDate = parseISO(item?.agreeddate);
  //         const currentDate = new Date();

  //         if (item?.intervaltypedesc === "Weeks") { // Weeks
  //           nextDate = addWeeks(startFromDate, item?.frequencyunit);
  //           while (isBefore(nextDate, currentDate)) {
  //             nextDate = addWeeks(nextDate, item?.frequencyunit);
  //           }
  //         } else if (item?.intervaltypedesc === "Months") { // Months
  //           nextDate = addMonths(startFromDate, item?.frequencyunit);
  //           while (isBefore(nextDate, currentDate)) {
  //             nextDate = addMonths(nextDate, item?.frequencyunit);
  //           }
  //         } else if (item?.intervaltypedesc === "Daily") { // Daily
  //           nextDate = addDays(startFromDate, item?.frequencyunit);
  //           while (isBefore(nextDate, currentDate)) {
  //             nextDate = addDays(nextDate, item?.frequencyunit);
  //           }
  //         }   

  //         const nextPpmDateFormatted = format(nextDate, 'dd/MM/yyyy');

  //         return {
  //           ...item,
  //           assetno: item?.assetno != undefined ? item?.assetno : '',
  //           agreeddateChanged: item?.agreeddate != undefined ? format(parseISO(item?.agreeddate), 'dd/MM/yyyy') : '',
  //           targetdateChanged: nextPpmDateFormatted,
  //           // targetdateChanged: format(parseISO(item?.targetdate), 'dd/MM/yyyy'),
  //         }
  //       })
  //       setRowCount(pdmList.data.totalCount);
  //       setExportCount(pdmList.data.totalCount)
  //       setRows(list)
  //     } else {
  //       const pdmList = await RoutineInspectionRepository.getBemsRIList(facilityId,pageSize,pageIndex,filterModel,sortModel);
  //       const list = pdmList?.data?.items?.map((item) => {
          
  //           // Calculate next date based on interval type with frequency Unit
  //           let nextDate;
  //           const startFromDate = parseISO(item?.agreeddate);
  //           const currentDate = new Date();
  
  //           if (item?.intervaltypedesc === "Weeks") { // Weeks
  //             nextDate = addWeeks(startFromDate, item?.frequencyunit);
  //             while (isBefore(nextDate, currentDate)) {
  //               nextDate = addWeeks(nextDate, item?.frequencyunit);
  //             }
  //           } else if (item?.intervaltypedesc === "Months") { // Months
  //             nextDate = addMonths(startFromDate, item?.frequencyunit);
  //             while (isBefore(nextDate, currentDate)) {
  //               nextDate = addMonths(nextDate, item?.frequencyunit);
  //             }
  //           } else if (item?.intervaltypedesc === "Daily") { // Daily
  //             nextDate = addDays(startFromDate, item?.frequencyunit);
  //             while (isBefore(nextDate, currentDate)) {
  //               nextDate = addDays(nextDate, item?.frequencyunit);
  //             }
  //           }                     
  //         const nextPpmDateFormatted = format(nextDate, 'dd/MM/yyyy');

  //         return {
  //           ...item,
  //           assetno: item?.assetno != undefined ? item?.assetno : '',
  //           agreeddateChanged: item?.agreeddate != undefined ? format(parseISO(item?.agreeddate), 'dd/MM/yyyy') : '',
  //           targetdateChanged: nextPpmDateFormatted,
  //           // targetdateChanged: format(parseISO(item?.targetdate), 'dd/MM/yyyy'),
  //         }
  //       }

  //       )
  //       setRowCount(pdmList.data.totalCount);
  //       setExportCount(pdmList.data.totalCount)
  //       setRows(list)
  //     }

  //   } catch (error) {
  //     console.error("Error fetching asset categories:", error);
  //   }
  //   finally {
  //     setLoading(false);
  //     setGridLoading(false);

  //   }
  // };

  const fetchList = async () => {
    try {
      setLoading(true);
      setGridLoading(true);
  
      const getList = serviceType?.label === 'FEMS'
        ? RoutineInspectionRepository.getRIList
        : RoutineInspectionRepository.getBemsRIList;
  
      const pdmList = await getList(facilityId, pageSize, pageIndex, filterModel, sortModel);
  
      const list = pdmList?.data?.items?.map((item) => {
  
        // Validate and parse agreeddate
        let startFromDate = null;
        if (item?.agreeddate) {
          startFromDate = parseISO(item.agreeddate);
          if (isNaN(startFromDate)) {
            console.warn("Invalid agreeddate format:", item.agreeddate);
            startFromDate = null;
          }
        }
  
        let nextDate = null;
        const currentDate = new Date();
  
        if (startFromDate) {
          switch (item?.intervaltypedesc) {
            case "Weeks":
              nextDate = addWeeks(startFromDate, item?.frequencyunit);
              while (isBefore(nextDate, currentDate)) {
                nextDate = addWeeks(nextDate, item?.frequencyunit);
              }
              break;
            case "Months":
              nextDate = addMonths(startFromDate, item?.frequencyunit);
              while (isBefore(nextDate, currentDate)) {
                nextDate = addMonths(nextDate, item?.frequencyunit);
              }
              break;
            case "Bi-Monthly":  // New condition for bi-monthly
              nextDate = addMonths(startFromDate, 2 * item?.frequencyunit);
              while (isBefore(nextDate, currentDate)) {
                nextDate = addMonths(nextDate, 2 * item?.frequencyunit);
              }
              break;
            case "Daily":
              nextDate = addDays(startFromDate, item?.frequencyunit);
              while (isBefore(nextDate, currentDate)) {
                nextDate = addDays(nextDate, item?.frequencyunit);
              }
              break;
            default:
              console.warn("Unknown interval type:", item?.intervaltypedesc);
          }
        }
  
        const nextPpmDateFormatted = nextDate ? format(nextDate, 'dd/MM/yyyy') : "Invalid Date";
  
        return {
          ...item,
          assetno: item?.assetno || '',
          agreeddateChanged: startFromDate ? format(startFromDate, 'dd/MM/yyyy') : "Invalid Date",
          targetdateChanged: nextPpmDateFormatted,
        };
      });
  
      setRowCount(pdmList.data.totalCount);
      setExportCount(pdmList.data.totalCount);
      setRows(list);
    } catch (error) {
      console.error("Error fetching asset categories:", error);
    } finally {
      setLoading(false);
      setGridLoading(false);
    }
  };
  

  const fetchExportData = async () => {
    try {
      
      if (serviceType?.label === 'FEMS') {
        const pdmList = await RoutineInspectionRepository.getRIForExport(facilityId,filterModel,sortModel);
        const list = pdmList?.data?.map((item) => {
          return {
            ...item,
            assetno:item?.assetno!=undefined?item?.assetno:'',
             agreeddateChanged:item?.agreeddate!=undefined?format(parseISO(item?.agreeddate), 'dd/MM/yyyy'):'',
            targetdateChanged: format(parseISO(item?.targetdate), 'dd/MM/yyyy'),
          }
        })
        setExportData(list)
      } else {
        const pdmList = await RoutineInspectionRepository.getBemsRIForExport(facilityId,filterModel,sortModel);
        const list = pdmList?.data?.map((item) => {
          return {
            ...item,
            assetno:item?.assetno!=undefined?item?.assetno:'',
            agreeddateChanged:item?.agreeddate!=undefined?format(parseISO(item?.agreeddate), 'dd/MM/yyyy'):'',
            targetdateChanged: format(parseISO(item?.targetdate), 'dd/MM/yyyy'),
          }
        }

        )
        setExportData(list)

      }

    } catch (error) {
      console.error("Error fetching asset categories:", error);
    }
   
  };

  useEffect(() => {
    const fetchOptions = async () => {
      setGridLoading(true);
      try {
        const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
        setServiceOptions(responseMasters);
        setServiceType(responseMasters?.find((item) => item?.label === 'FEMS'));
      } catch (e) {
        console.error(e);
      }
    }
    fetchOptions();
  }, []);


  // const serviceOptionsChange = useMemo(() => {
  //   try {
  //     setServiceType(serviceOptions?.find((item) => item?.label === 'FEMS'));
  //   } catch (e) {
  //     console.log("error fetching resource")
  //   }
  //   // fetchList();

  // }, [serviceOptions]);

  const serviceChange = useMemo(() => {
    if (serviceType?.label != '' && serviceType?.label != undefined) {
      // if (!hasRun.current) {
        fetchList();
      //   hasRun.current = true;
      // }
    }

  }, [serviceType,filterModel, sortModel, pageIndex, pageSize]);

  const handleEdit = (rowData) => {
    navigate("register", {
      state: { ...rowData, readOnlyEdit: true, mode: "edit", service: serviceType?.label, serviceTypeDetails: serviceType,schYear:rowData?.schyear },
    });
  };
  const handleView = (rowData) => {
    navigate("register", {
      state: { ...rowData, readOnly: true, mode: "view", service: serviceType?.label, serviceTypeDetails: serviceType },
    });
  };


  const handleCreateRI = () => {
    navigate("register", {
      state: { service: serviceType?.label, mode: "create", pdmList: rows },
    });
  };


  const handleDelete = async (row) => {

    //  const response = serviceType?.label === "FEMS" ? await RoutineInspectionRepository.removeRIList(row?.id) : await RoutineInspectionRepository.removeBemsRIList(row?.id); // Use typecodeId for deletion


    if (row?.id) {
      // const deleteSchedule = serviceType?.label === "FEMS" ? await RoutineInspectionRepository.getRIShowSchedule(row?.id) : await RoutineInspectionRepository.getBemsRIShowSchedule(row?.id);
      setAllTracks([1]);
    }
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    // const response = serviceType?.label === "FEMS" ? await RoutineInspectionRepository.removeRIList(rowToDelete?.id) : await RoutineInspectionRepository.removeBemsRIList(rowToDelete?.id); // Use typecodeId for deletion
    //  await fetchList();
    try {
      if (rowToDelete) {
        let id = rowToDelete?.id;

        if (allTracks?.length > 0) {

          if (allTracks?.length > 0) {
            const setTracks = allTracks.map(async (item) => {
              const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ? await RoutineInspectionRepository.removeRIScheduleTracks(id) : await RoutineInspectionRepository.removeBemsRIScheduleTracks(id);
              return updatePpmScheduleTracks;
            });

            const updatePpmScheduleTracksDelete = await Promise.all(setTracks)
            let isDeleteTracks = updatePpmScheduleTracksDelete.every(result => result.status <= 204);
            if (isDeleteTracks) {
              const response = serviceType?.label === "FEMS" ? await RoutineInspectionRepository.removeRIList(id) : await RoutineInspectionRepository.removeBemsRIList(id); // Use typecodeId for deletion
              if (response?.status >= 200 && response?.status <= 204)
                setDeleteDialogOpen(false);
              setConfirmationDialogOpen(true);
              setRowToDelete(null); // Clear the row to delete after deletion
              await fetchList();
            }
          }
        } else if (id && allTracks?.length === 0) {
          // const response = serviceType?.label === "FEMS" ? await PremitiveMaintenanceRepository.removePdmList(id) : await PremitiveMaintenanceRepository.removeBemsPdmList(id); // Use typecodeId for deletion
          const response = serviceType?.label === "FEMS" ? await RoutineInspectionRepository.removeRIList(id) : await RoutineInspectionRepository.removeBemsRIList(id); // Use typecodeId for deletion        
          if (response?.status >= 200 && response?.status <= 204) {
            setDeleteDialogOpen(false);
            setConfirmationDialogOpen(true);
            setRowToDelete(null); // Clear the row to delete after deletion
            await fetchList();
          }
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  };
  const handleCancelClick = () => {
    navigate('/dashboard');
  }
  
  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };
  return (
    <>
      <PageLoader open={loading} />
      <PageTitle title={"Routine Inspection"} />
      <DefaultCard>
        <Box
          mb={1}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <SectionTitle title="Routine Inspection List" />
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Service"}
              value={serviceType}
              options={serviceOptions}
              placeholder={"Select Service"}
              highlight={true}
              onChange={(newValue) => {

                if (newValue?.label != '') {
                  hasRun.current = false;
                }
                setServiceType(newValue);

              }}
            />
            {access?.canCreate && <CreateNewButton onClick={handleCreateRI} />}
            <RefreshExportButtons exportFunction={fetchExportData} exportData={exportData} title='RI Maintenance' refData={gridApi} handleRefresh={handleRefresh} />

            {/* <RefreshExportButtons
              exportFunction={() => { }}
              data={rows}
              refData={gridApi}
              handleRefresh={handleRefresh}
              title={"Routine Inspection"}
            /> */}
          </Stack>
        </Box>
        <CustomAgGrid
          rows={rows}
          columns={columns}
          handleEdit={access?.canEdit && handleEdit}
          handleDelete={access?.canDelete && handleDelete}
          handleView={access?.canView && handleView}
          setGridApi={setGridApi}
          isLoading={gridLoading}
          headerLayer = {3}
          pagination ={false}
          setFilterModel={setFilterModel}
          setSortModel={setSortModel}
          totalCount={rowCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
        />
                <Grid container spacing={2}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', margin: "10px" }}>
              {/* <Button variant='contained' onClick={handleSaveClick} sx={{ margin: "10px" }}>Save</Button> */}
              <Button variant='outlined' onClick={handleCancelClick} sx={{ margin: "10px" }}>BACK</Button>

            </Grid>
          </Grid>
        <CustomDialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onConfirm={confirmDelete}
          title="Confirmation!"
          content="Are you sure you want to delete?"
          cancelBtn="No"
          confirmBtn="Yes"
        />
        <CustomDialog
          open={confirmationDialogOpen}
          onClose={() => setConfirmationDialogOpen(false)}
          title="Deletion Successful"
          content="Record deleted successfully."
          confirmBtn="OK"
          onConfirm={() => setConfirmationDialogOpen(false)}
        />
      </DefaultCard>
    </>
  )

}
